package acupoint.components

import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.message.message
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import kotlinext.js.Object
import react.*
import react.dom.div
import acupoint.containers.AcupointNoteEditPageContext
import kotlinx.browser.window
import react.router.dom.useHistory
import user.service.AuthService

external interface AcupointNoteEditProps : RProps {
    var acupointId: String
    var noteId: String
}

val AcupointNoteEdit = functionalComponent<AcupointNoteEditProps> { props ->

    val ctx = useContext(AcupointNoteEditPageContext)
    val history = useHistory()
    
    val (note, setNote) = useState(Comment().apply {
        entityType = CommentEntityType.Acupoint
        entityId = props.acupointId
        type = CommentType.笔记
        description = ""
        comment = ""
        authorId = AuthService.getUserAuthData()?.id ?: ""
        createdBy = AuthService.getUserAuthData()?.userName ?: ""
        weight = 0
    })

    fun onSave(event: dynamic) {
        if (note.comment.isNullOrBlank()) {
            message.error("请填写笔记内容")
            return
        }
        
        message.loading("正在保存", 5)
        ctx.save(note, { resp ->
            if (resp.ok()) {
                message.success("保存成功")
                window.history.back()
            } else {
                message.error("抱歉，出错了：${resp.message}")
            }
        }, {
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    useEffectOnce {
        if ("new" != props.noteId && props.noteId.length == 32) {
            ctx.getCommentById(props.noteId, { resp ->
                if (resp.ok() && resp.data != null) {
                    setNote(resp.data!!)
                } else {
                    message.error("获取笔记失败")
                }
            }, {
                message.error("获取笔记失败")
            })
        }
    }

    div("AcupointNoteEdit") {
        form {
            attrs {
                layout = "horizontal"
            }
            
            formItem {
                attrs {
                    label = "笔记标题"
                }
                input {
                    attrs {
                        value = note.title ?: ""
                        placeholder = "请填写笔记标题（可选）"
                        onChange = { event: dynamic ->
                            val _note = Object.assign(Comment(), note)
                            _note.title = event.target.value as String
                            setNote(_note)
                        }
                    }
                }
            }

            formItem {
                attrs {
                    label = "笔记内容"
                }
                textArea {
                    attrs {
                        value = note.comment ?: ""
                        rows = 10
                        placeholder = "请填写笔记内容"
                        onChange = { event: dynamic ->
                            val _note = Object.assign(Comment(), note)
                            _note.comment = event.target.value as String
                            setNote(_note)
                        }
                    }
                }
            }
            
            formItem {
                attrs {
                    label = "排序权重"
                }
                input {
                    attrs {
                        type = "number"
                        value = (note.weight ?: 0).toString()
                        onChange = { event: dynamic ->
                            val _note = Object.assign(Comment(), note)
                            _note.weight = (event.target.value as String).toIntOrNull() ?: 0
                            setNote(_note)
                        }
                    }
                }
            }

            formItem {
                button {
                    attrs {
                        type = "primary"
                        onClick = ::onSave
                    }
                    +"保存笔记"
                }
                
                button {
                    attrs {
                        style = kotlinext.js.js {
                            marginLeft = "8px"
                        }
                        onClick = {
                            window.history.back()
                        }
                    }
                    +"取消"
                }
            }
        }
    }
}
